// ================================================================
// Org management API — اعضا، نقش‌ها، دعوت‌ها (سازمانِ خودِ کاربر)
// ================================================================
// getToken() bleibt hier direkt importiert: die FormData-Uploads unten (Anhänge,
// Briefpapier-Hintergrund) und die Blob-Downloads brauchen eigene Header/Antwortform —
// die können nicht über apiRequest() laufen.
import { getToken } from './auth.js';
import { apiRequest, readErrorMessage } from './apiClient.js';

// تم سازمان (org-branding)
export function getOrgTheme() { return apiRequest('/api/org-theme'); }
export function setOrgThemeApi(theme) {
  return apiRequest('/api/org-theme', { method: 'PUT', body: JSON.stringify({ theme }) });
}

// اعضا
export function listMembers() { return apiRequest('/api/members'); }
export function setMemberRole(id, roleId) {
  return apiRequest('/api/members/' + encodeURIComponent(id) + '/role', { method: 'PATCH', body: JSON.stringify({ roleId }) });
}
export function setMemberStatus(id, status) {
  return apiRequest('/api/members/' + encodeURIComponent(id) + '/status', { method: 'PATCH', body: JSON.stringify({ status }) });
}

export function setMemberName(id, name) {
  return apiRequest('/api/members/' + encodeURIComponent(id) + '/name', { method: 'PATCH', body: JSON.stringify({ name }) });
}

// eigenes Profil bearbeiten — jeder eingeloggte User, ohne members:write
export function updateOwnProfile(data) {
  return apiRequest('/api/members/me', { method: 'PATCH', body: JSON.stringify(data) });
}

// vollständiges Mitarbeiter-Profil bearbeiten (Admin, members:write)
export function updateMemberProfile(id, data) {
  return apiRequest('/api/members/' + encodeURIComponent(id) + '/profile', { method: 'PATCH', body: JSON.stringify(data) });
}

// vollständiges Profil lesen (inkl. sensibler Felder) — self bzw. Admin
export function getOwnProfileFull() { return apiRequest('/api/members/me/full'); }
export function getMemberProfileFull(id) { return apiRequest('/api/members/' + encodeURIComponent(id) + '/full'); }

// نقش‌ها (سطوح دسترسی)
export function listRoles() { return apiRequest('/api/roles'); }
export function createRole(data) { return apiRequest('/api/roles', { method: 'POST', body: JSON.stringify(data) }); }
export function updateRole(id, data) { return apiRequest('/api/roles/' + encodeURIComponent(id), { method: 'PUT', body: JSON.stringify(data) }); }

// دعوت‌ها
export function listInvitationRoles() { return apiRequest('/api/invitations/roles'); }
export function listInvitations() { return apiRequest('/api/invitations'); }
// createInvitation(payload) ODER (legacy) createInvitation(email, roleId)
export function createInvitation(payload, roleIdLegacy) {
  const body = typeof payload === 'string'
    ? { email: payload, roleId: roleIdLegacy || null }
    : payload;
  return apiRequest('/api/invitations', { method: 'POST', body: JSON.stringify(body) });
}
export function revokeInvitation(id) { return apiRequest('/api/invitations/' + encodeURIComponent(id), { method: 'DELETE' }); }

// ── سطل آشغال: اعضا ──
export function removeMember(id) { return apiRequest('/api/members/' + encodeURIComponent(id), { method: 'DELETE' }); }
export function listMembersTrash() { return apiRequest('/api/members/trash'); }
export function restoreMember(id) { return apiRequest('/api/members/' + encodeURIComponent(id) + '/restore', { method: 'POST' }); }
export function purgeMember(id) { return apiRequest('/api/members/' + encodeURIComponent(id) + '/permanent', { method: 'DELETE' }); }

// ── Arbeitszeitmodelle (Soll-Arbeitszeit) ──
export function listWorkTimeModels() { return apiRequest('/api/working-time-models'); }
export function getWorkTimeModel(id) { return apiRequest('/api/working-time-models/' + encodeURIComponent(id)); }
export function createWorkTimeModel(data) { return apiRequest('/api/working-time-models', { method: 'POST', body: JSON.stringify(data) }); }
export function updateWorkTimeModel(id, data) { return apiRequest('/api/working-time-models/' + encodeURIComponent(id), { method: 'PATCH', body: JSON.stringify(data) }); }
export function deleteWorkTimeModel(id) { return apiRequest('/api/working-time-models/' + encodeURIComponent(id), { method: 'DELETE' }); }

// ── Lohngruppen (Lohnkosten/Verrechnungssatz) ──
export function listWageGroups() { return apiRequest('/api/wage-groups'); }
export function getWageGroup(id) { return apiRequest('/api/wage-groups/' + encodeURIComponent(id)); }
export function createWageGroup(data) { return apiRequest('/api/wage-groups', { method: 'POST', body: JSON.stringify(data) }); }
export function updateWageGroup(id, data) { return apiRequest('/api/wage-groups/' + encodeURIComponent(id), { method: 'PATCH', body: JSON.stringify(data) }); }
export function deleteWageGroup(id) { return apiRequest('/api/wage-groups/' + encodeURIComponent(id), { method: 'DELETE' }); }

// ── Bausteine (Bibliothek wiederverwendbarer Angebots-Positionen) ──
export function listBausteine() { return apiRequest('/api/bausteine'); }
export function createBaustein(data) { return apiRequest('/api/bausteine', { method: 'POST', body: JSON.stringify(data) }); }
export function updateBaustein(id, data) { return apiRequest('/api/bausteine/' + encodeURIComponent(id), { method: 'PATCH', body: JSON.stringify(data) }); }
export function deleteBaustein(id) { return apiRequest('/api/bausteine/' + encodeURIComponent(id), { method: 'DELETE' }); }

// ── Feiertage (gesetzliche Feiertage pro Kanton) ──
export function getHolidays(year) { return apiRequest('/api/holidays' + (year ? '?year=' + encodeURIComponent(year) : '')); }
export function generateHolidays(region, year) { return apiRequest('/api/holidays/generate?region=' + encodeURIComponent(region) + (year ? '&year=' + encodeURIComponent(year) : '')); }
export function saveHolidays(data) { return apiRequest('/api/holidays', { method: 'PUT', body: JSON.stringify(data) }); }

// ── Einheiten (Mengeneinheiten + Standardwerte) ──
export function getUnits() { return apiRequest('/api/units'); }
export function saveUnits(units) { return apiRequest('/api/units', { method: 'PUT', body: JSON.stringify({ units }) }); }
export function saveUnitDefaults(defaults) { return apiRequest('/api/units/defaults', { method: 'PUT', body: JSON.stringify({ defaults }) }); }

// ── Zuschläge (%-Voreinstellung je Positionsart) ──
export function getSurcharges() { return apiRequest('/api/surcharges'); }
export function saveSurcharges(surcharges) { return apiRequest('/api/surcharges', { method: 'PUT', body: JSON.stringify({ surcharges }) }); }

// ── Buchhaltung: Nummernkreise + Zahlungsziel & Skonto ──
export function getNumberRanges() { return apiRequest('/api/accounting/number-ranges'); }
export function saveNumberRanges(numberRanges) { return apiRequest('/api/accounting/number-ranges', { method: 'PUT', body: JSON.stringify({ numberRanges }) }); }
export function getPaymentTerms() { return apiRequest('/api/accounting/payment-terms'); }
export function savePaymentTerms(paymentTerms) { return apiRequest('/api/accounting/payment-terms', { method: 'PUT', body: JSON.stringify({ paymentTerms }) }); }
export function getPaymentCode() { return apiRequest('/api/accounting/payment-code'); }
export function savePaymentCode(paymentCode) { return apiRequest('/api/accounting/payment-code', { method: 'PUT', body: JSON.stringify({ paymentCode }) }); }
export function getPartialInvoiceSettings() { return apiRequest('/api/accounting/partial-invoice-settings'); }
export function savePartialInvoiceSettings(partialInvoiceSettings) { return apiRequest('/api/accounting/partial-invoice-settings', { method: 'PUT', body: JSON.stringify({ partialInvoiceSettings }) }); }
export function getLabourCostDisplay() { return apiRequest('/api/accounting/labour-cost-display'); }
export function saveLabourCostDisplay(labourCostDisplay) { return apiRequest('/api/accounting/labour-cost-display', { method: 'PUT', body: JSON.stringify({ labourCostDisplay }) }); }

// ── Layout & Textvorlagen: Anfangs- & Schlusstexte ──
export function getDocumentTexts() { return apiRequest('/api/document-texts'); }
export function saveDocumentTexts(documentTexts) { return apiRequest('/api/document-texts', { method: 'PUT', body: JSON.stringify({ documentTexts }) }); }

// ── Layout & Textvorlagen: Dateinamen-Schema ──
export function getFileNaming() { return apiRequest('/api/file-naming'); }
export function saveFileNaming(fileNaming) { return apiRequest('/api/file-naming', { method: 'PUT', body: JSON.stringify({ fileNaming }) }); }

// ── Layout & Textvorlagen: E-Mail Versand Defaults ──
export function getEmailSettings() { return apiRequest('/api/email-settings'); }
export function saveEmailSettings(emailDefaults) { return apiRequest('/api/email-settings', { method: 'PUT', body: JSON.stringify({ emailDefaults }) }); }

// Begleittext der WhatsApp-Nachricht. Leere Felder = eingebauter Standardtext,
// der bereits in allen Dokumentsprachen vorliegt (siehe settingsWhatsappText.js).
export function getWhatsappTextSettings() { return apiRequest('/api/whatsapp-text'); }
export function saveWhatsappTextSettings(whatsappDefaults) { return apiRequest('/api/whatsapp-text', { method: 'PUT', body: JSON.stringify({ whatsappDefaults }) }); }

// ── Layout & Textvorlagen: Briefpapier ──
export function getLetterhead() { return apiRequest('/api/letterhead'); }
export function saveLetterhead(patch) { return apiRequest('/api/letterhead', { method: 'PUT', body: JSON.stringify(patch) }); }
export function saveContactPersons(contactPersons) { return apiRequest('/api/letterhead/contact-persons', { method: 'PUT', body: JSON.stringify({ contactPersons }) }); }
export function getLetterheadPreview() { return apiRequest('/api/letterhead/preview'); }
// PDF-Gestaltung der Offerte: 'STANDARD' | 'UMZUG' (Organization.documentLayout)
export function getDocumentLayout() { return apiRequest('/api/letterhead/document-layout'); }
export function saveDocumentLayout(documentLayout) { return apiRequest('/api/letterhead/document-layout', { method: 'PUT', body: JSON.stringify({ documentLayout }) }); }
export function saveLetterheadLayout(patch) { return apiRequest('/api/letterhead/layout', { method: 'PUT', body: JSON.stringify(patch) }); }
export function deleteLetterheadBackground(slot) { return apiRequest(`/api/letterhead/background/${slot}`, { method: 'DELETE' }); }

// ── Automatische Anhänge ──
export function getAttachments() { return apiRequest('/api/attachments'); }

// ── Mahnungen ──
export function getDunning() { return apiRequest('/api/dunning'); }
export function saveDunning(patch) { return apiRequest('/api/dunning', { method: 'PUT', body: JSON.stringify(patch) }); }

// ── Verbindungen (Gmail-Konten; WhatsApp läuft über core/whatsapp.js) ──
export function listConnections() { return apiRequest('/api/connections'); }
// Trennt die Verbindung: das Backend widerruft den Zugriff bei Google UND löscht sie.
export function deleteConnection(id) { return apiRequest(`/api/connections/${id}`, { method: 'DELETE' }); }
// Löscht ZUSÄTZLICH die synchronisierten Gmail-Mails (Betreff/Text/Anhänge) —
// getrennt von deleteConnection, das die Mail-Historie bewusst behält.
export function deleteConnectionData(id) { return apiRequest(`/api/connections/${id}/data`, { method: 'DELETE' }); }
export function deleteAttachment(id) { return apiRequest(`/api/attachments/${id}`, { method: 'DELETE' }); }
export async function uploadAttachment(docType, file) {
  const token = getToken();
  const fd = new FormData();
  fd.append('file', file);
  // kein Content-Type setzen — den Multipart-Boundary bestimmt der Browser
  const res = await fetch(`/api/attachments/${docType}`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: fd,
  });
  let body = {};
  try { body = await res.json(); } catch { /* no body */ }
  if (!res.ok) {
    const err = new Error(readErrorMessage(body, res.status));
    err.status = res.status;
    err.code = body?.error?.code;
    throw err;
  }
  return body;
}
export async function fetchAttachmentBlob(id) {
  const token = getToken();
  const res = await fetch(`/api/attachments/${id}/file`, {
    headers: { ...(token ? { Authorization: 'Bearer ' + token } : {}) },
  });
  if (!res.ok) return '';
  return URL.createObjectURL(await res.blob());
}
// Hintergrund-Upload: multipart, deshalb kein JSON-Body (apiRequest() setzt Content-Type: application/json)
export async function uploadLetterheadBackground(slot, file) {
  const token = getToken();
  const fd = new FormData();
  fd.append('background', file);
  // kein Content-Type setzen — den Multipart-Boundary muss der Browser bestimmen
  const res = await fetch(`/api/letterhead/background/${slot}`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: fd,
  });
  let body = {};
  try { body = await res.json(); } catch { /* no body */ }
  if (!res.ok) {
    const err = new Error(readErrorMessage(body, res.status));
    err.status = res.status;
    err.code = body?.error?.code;
    throw err;
  }
  return body;
}
// Vorschaubild der Hintergrund-Karte (Auth nötig → als Blob holen, wie beim Logo)
export async function fetchLetterheadBackgroundBlob(slot) {
  const token = getToken();
  const res = await fetch(`/api/letterhead/background/${slot}/thumb`, {
    headers: { ...(token ? { Authorization: 'Bearer ' + token } : {}) },
  });
  if (!res.ok) return '';
  return URL.createObjectURL(await res.blob());
}

// ── سطل آشغال: نقش‌ها ──
export function deleteRole(id) { return apiRequest('/api/roles/' + encodeURIComponent(id), { method: 'DELETE' }); }
export function listRolesTrash() { return apiRequest('/api/roles/trash'); }
export function restoreRole(id) { return apiRequest('/api/roles/' + encodeURIComponent(id) + '/restore', { method: 'POST' }); }
export function purgeRole(id) { return apiRequest('/api/roles/' + encodeURIComponent(id) + '/permanent', { method: 'DELETE' }); }
